import { useState, forwardRef } from 'react';
import styled from 'styled-components';
import {
  IconArrowTopRight,
  SemanticTextColor,
  TextLink,
  Type,
} from '@spotify-internal/encore-web';

const StyledTextLink = styled(TextLink)`
  display: flex;
  align-items: center;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const ValueTextContainer = styled.div<{ hasTextUnderline: boolean }>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 6px;
  ${({ hasTextUnderline }) =>
    hasTextUnderline &&
    `
  text-decoration: underline;
  `}
  &:hover {
    text-decoration: underline;
  }

  @media (max-width: 700px) {
    max-width: 240px;
    padding-right: 0px;
  }
`;

const IconContainer = styled.div`
  padding: 6px 4px 0 4px;
`;

const StyledIconArrow = styled(IconArrowTopRight)<{ show: boolean }>`
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
`;

interface TextLinkToExternalProps {
  href: string | undefined;
  valueText: string;
  valueTextColor: SemanticTextColor;
  hasTextUnderline: boolean;
  handleClick: (() => void) | undefined;
}

export const TextLinkToExternal = forwardRef<
  HTMLAnchorElement | null,
  TextLinkToExternalProps
>(
  (
    {
      href,
      valueText,
      valueTextColor,
      hasTextUnderline,
      handleClick,
    }: TextLinkToExternalProps,
    ref,
  ) => {
    const [linkIsHovered, setLinkIsHovered] = useState(false);

    const handleOnClick = () => {
      if (handleClick) {
        handleClick();
      }
    };

    return (
      <StyledTextLink
        ref={ref}
        href={href}
        standalone
        aria-label="styled-text-link"
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setLinkIsHovered(true)}
        onMouseLeave={() => setLinkIsHovered(false)}
        onClick={handleOnClick}
      >
        <ValueTextContainer hasTextUnderline={hasTextUnderline}>
          <Type variant="viola" semanticColor={valueTextColor}>
            {valueText}
          </Type>
        </ValueTextContainer>
        <IconContainer>
          <StyledIconArrow
            iconSize={16}
            semanticColor="textSubdued"
            aria-label="Link to external page"
            show={linkIsHovered}
          />
        </IconContainer>
      </StyledTextLink>
    );
  },
);
